'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reduxDeviceDetection = require('@wh/redux-device-detection');

var _reduxDeviceDetection2 = _interopRequireDefault(_reduxDeviceDetection);

var _languageCommon = require('@wh/language-common');

var _languageCommon2 = _interopRequireDefault(_languageCommon);

var _timezone = require('./timezone');

var _timezone2 = _interopRequireDefault(_timezone);

var _currentUrl = require('./currentUrl');

var _currentUrl2 = _interopRequireDefault(_currentUrl);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    getPlatform: _reduxDeviceDetection2.default,
    getActiveLanguageAndCountryCode: _languageCommon.getActiveLanguageAndCountryCode,
    getActiveLanguageCode: _languageCommon2.default,
    getTimezone: _timezone2.default,
    getCurrentUrl: _currentUrl2.default
};
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@wh/redux-global-settings/dist/main/selectors/index.js
// module id = 525
// module chunks = 0